// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".educational-impact--container {\n  height: 440px;\n  background-color: #F0F0F3; }\n\n@media screen and (max-width: 800px) {\n  .educational-impact--container {\n    height: auto; } }\n", ""]);
// Exports
module.exports = exports;
